import template from './header.html';
import './header.scss';

export class HeaderController {
  constructor($timeout, appUtils) {
    'ngInject';

    this.$timeout = $timeout;
    this.appUtils = appUtils;
    this.showPopover = false;
    this.windowListenerAttached = false;
    this.avatarLetter = '';
    this.avatarStyleNumber = 1;
    this._onClickOnWindow = this._onClickOnWindow.bind(this);
  }
  $onChanges({ accountName }) {
    if (
      accountName.currentValue &&
      accountName.previousValue !== accountName.currentValue
    ) {
      this._generateAvatar(accountName.currentValue);
    }
  }
  $onDestroy() {
    this.removeWindowListener();
  }
  addWindowListener() {
    if (!this.windowListenerAttached) {
      this.appUtils.attachWindowEvents('click', this._onClickOnWindow);
      this.windowListenerAttached = true;
    }
  }
  removeWindowListener() {
    if (this.windowListenerAttached) {
      this.appUtils.detachWindowEvents('click', this._onClickOnWindow);
      this.windowListenerAttached = false;
    }
  }
  openPopover($event) {
    $event.preventDefault();
    this.showPopover = true;
    this.$timeout(() => this.addWindowListener());
  }
  closePopover() {
    this.showPopover = false;
    this.removeWindowListener();
  }
  closePopoverAfterEvent() {
    this.$timeout(() => this.closePopover());
  }
  onPopoverClick($event) {
    $event.stopPropagation();
  }
  handleAction(action) {
    this.onActionClicked({ action });
  }
  handlePopoverAction(popoverOption) {
    this.onPopoverActionClicked({ action: popoverOption });
  }
  _onClickOnWindow(event) {
    if (this.showPopover) {
      event.stopPropagation();
      event.preventDefault();
      this.closePopoverAfterEvent();
    }
  }
  _generateAvatar(name) {
    this.avatarLetter = name.substr(0, 1).toLowerCase();
    const lettersCodeStartPosition = 97;
    const letterN = this.avatarLetter.charCodeAt(0) - lettersCodeStartPosition;
    const defaultStyle = 1;
    const firstAlternativeStyle = 2;
    const secondAlternativeStyle = 3;

    let style = defaultStyle;
    if (letterN % secondAlternativeStyle === 0) {
      style = secondAlternativeStyle;
    } else if (letterN % firstAlternativeStyle === 0) {
      style = firstAlternativeStyle;
    }

    this.avatarStyleNumber = style;
  }
}

export default {
  controller: HeaderController,
  template,
  bindings: {
    accountName: '<',
    popoverOptions: '<',
    onPopoverActionClicked: '&',
    actions: '<',
    onActionClicked: '&',
  },
};
